<template>
    <div class="h-100">
        <div style="height:55px;border-bottom: 1px solid #1e1e1e;padding:8px 0px;" class="filter-fields-in-logs w-100">
            <!-- <div class="primary-btn-style justify-content-end"  style="padding:0px !important;height:100%;diplay:inline-block;">
                <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;margin:0px !important;width:85px;margin-inline-end:10px;" v-on:click="editUser('users-info')">Download</button>
            </div> -->
            <button-top-bar
             v-on:click.native="downloadStorageReportData()"
            >
            </button-top-bar>
        </div>
        <div class="storage-report-div" style="margin-top: 16px;">
            <table class="tabletable-with-border table-scroll small-first-col"  style="background: transparent;width:100%;">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 36%" class="text-left">{{$t('BinName')}}</th>
                        <th style="width: 12%"   class="text-left">{{$t('Total space')}}</th>
                        <th style="width: 12%"   class="text-left">{{$t('Used space')}}</th>
                        <th style="width: 12%;text-align:start">{{$t('Free space')}}</th>
                        <th style="width: 34%;text-align:center">{{$t('Usage in Percentage')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in storageReportData"
                        :key="item.bin_id"
                        class="ccomm-item-row" :class="{activeclass: activeIndex === item.bin_id}">
                        <td>
                            <span v-if="Object.keys(item).includes('bin_id') && item.bin_id.length > 0">{{ item.bin_id }}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </td> 
                        <td>
                            <span v-if="Object.keys(item).includes('total_space') && (item.total_space != null || item.total_space != undefined)">{{ item.total_space == '-'?'NA':getConvertedFileSize(item.total_space) }}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </td> 
                        <td>
                            <span v-if="Object.keys(item).includes('used_space') && (item.used_space != null || item.used_space != undefined)">{{ item.used_space == '-'?'NA':getConvertedFileSize(item.used_space) }}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </td>
                        <td>
                            <span v-if="Object.keys(item).includes('free_space') && (item.free_space != null || item.free_space != undefined)">{{ item.free_space == '-'?'NA':getConvertedFileSize(item.free_space) }}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </td>   
                        <td>
                            <div style="width:100%;display: flex;align-items: center;">
                                <div v-if="item.percent == '-'">
                                    NA
                                </div>
                                <div v-else class="comm-center-align progress">
                                    <div 
                                    class="progress-bar progress-bar-success" 
                                    v-if="Object.keys(item).includes('percent') && (item.percent != null || item.percent != undefined)" 
                                    role="progressbar"
                                    :aria-valuenow="item.percent" 
                                    aria-valuemin="0" 
                                    aria-valuemax="100"
                                    :class="{progressBarGoingExceed:item.percent>75}"
                                    v-bind:style="[{width:(item.percent) + '%'}]"
                                    >{{item.percent}}%</div>

                                    <!-- <div 
                                        class="progress-bar progress-bar-success" 
                                        role="progressbar" 
                                        aria-valuenow="40" 
                                        aria-valuemin="0" 
                                        aria-valuemax="100" 
                                        style="width:40%">
                                    45% Complete (success)
                                    </div> -->


                                    <span v-else class="validationmessage">No Data found</span>
                                </div>
                                <!-- <div class="comm-center-align">
                                    <span>{{getConvertedFileSize(item.used_space)}}/ {{getConvertedFileSize(item.total_space)}}</span>
                                </div> -->
                            </div>
                        </td>
                        
                    </tr>
                </tbody>    
            </table>    
        </div>    
        <div>
            <!-- <pagination
                v-model="page"
                :records="totalUsersLogs"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
                style="margin-top:10px"
            /> -->
        </div>
    </div>       
</template> 

<script>
    import { mapActions } from "vuex";
    // import Utils from "../../components.utils.js";  
    import buttonsTopbar from "./headerbar.vue";
    // import Pagination from "vue-pagination-2";
    // import KProgress from 'k-progress';
    export default {
        data(){
                return{
                    page: 1,
                    totalPages: -1,
                    totalUsersLogs: -1,
                    perPage: -1,
                    storageReportData:[],
                    activeIndex:null,
                } 
        },  
        components:{
            // 'k-progress': KProgress,
            // pagination: Pagination,
            "button-top-bar":buttonsTopbar,
        },
        methods:{
            
            refreshStorageReports(isPageClick = false) {  
                this.getStorageReportFromServer().then((data) => {
                    this.totalPages = data["page_count"];
                    this.page = data["page"];
                    this.totalUsersLogs = data["total_user_logs"];
                    this.perPage = data["user_logs_per_page"];
                    this.storageReportData = data.bins_storage_info;
                    // this.auditLogUserMap = data.user_map;
                    // this.userListFromAutocomplete = []
                    // this.userGroupListFromAutocomplete = []
                    let paramsInfo = {}
                    if(isPageClick){
                        paramsInfo.page = this.page
                    }
                }); 
            },  
            
            downloadStorageReportData() {
                // let filePath = url;
                this.$toast.info("You will be notified once the report is ready to download");
                this.downloadStorageReportFromServer().then(() => {
                    console.log("Downloading report")
                // const blob = new Blob([response.data], {
                //     type: "application/vnd.csv",
                // });
                // const link = document.createElement("a");
                // link.href = URL.createObjectURL(blob);
                // link.setAttribute(
                //     "download",
                //     response.headers["content-disposition"].split("filename=")[1]
                // );
                // document.body.appendChild(link);
                // link.click();
                })
                .catch(console.error);
            },

            getConvertedFileSize(size){
                // return Utils.getConvertedFileSize(size);
                const i = Math.floor(Math.log(size) / Math.log(1024)),
                sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                return (size / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
            },  

            handleStorageNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    this.refreshStorageReports(false)
                }
            },
            // registerforWebsocketNotifications(){
            //     this.addWSEventListener({
            //         eventname:["JOB_STATUS_UPDATE"],
            //         callback:this.handleStorageNotification,
            //         parent: "StorageReports"})
            // },
            // unRegisterforWebsocketNotifications(){
            //     this.removeWSEventListener({
            //         eventname:["JOB_STATUS_UPDATE"],
            //         callback:this.handleStorageNotification,
            //         parent: "StorageReports"})
            // },
            // ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("storageReports", ["getStorageReportFromServer", "downloadStorageReportFromServer"]),
        },
        created(){
            this.refreshStorageReports(false);
            // this.registerforWebsocketNotifications();
        },
        beforeDestroy(){
            // this.unRegisterforWebsocketNotifications()
        }
    };
</script>

<style scoped lang="scss">
    $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

    .user-logs-table{
        height: calc(100% - 185px);
        overflow:auto;
    }
    .comm-center-align{
        display:flex;
        align-items: center;
    }
    .progress{
        background: transparent;
        width: 100%;
        border: 1px solid #545454;
        height: 18px;
        div{
            height: 30px;
            margin-inline-end: 15px;
            border-radius: 4px;
            // width:100%;
        }
    }

    .progressBarGoingExceed{
        background: red;
    }
    .storage-report-div{
        padding: 0px 30px 10px 30px;
        overflow: auto;
        height: calc(100% - 114px);
    }

    .table-scroll tbody tr{
        border-bottom: $secondary-border-color;
    }

    .table-scroll thead th {
        position: sticky;
        top: 0;
        background: #141414;
        z-index: 9;
    }

     th, td{
        text-align: start;
    }

    tbody tr{
        border-bottom: $secondary-border-color;
    }

    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
            height: 38px;
            width: 70px;
            font-size:14px;
        }
        .text-light:hover{
        text-decoration: underline;
        }
    }
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
            position: sticky;
            top: 0;
            background:$primary-background;
            z-index:9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
            height:60px;
            }
        }
    }

    /* width */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }
</style>